import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom'
import {LOYALTY_STYLE_PROPERTIES} from './loyalty_consts';
import _ from '../../utils/underscore';
import {SYSTEM_EVENTS} from "../../events/events";


class LoyaltyComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'LoyaltyComponentController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-loyalty';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;

    /**
     * @type {{}}
     * @private
     */
    _params = {};

    _firebaseToken = null; // token retrieved by firebase strategy when firebase object is created. loyalty should subscribe to firebase with the same token

    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._params = params;
        this.onSystemEvent(SYSTEM_EVENTS.FIREBASE_GOT_NEW_TOKEN, this._updateLoyaltyToken);
        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOAuthChange);
        this._setParamsToLowerCase(this._params);
    }

    /**
     *
     * @returns {LoyaltyComponentController}
     */
    start() {
        if( this.serviceFactory.oAuth2Service().isAuthorized()){
            this._appendScript();
        }
    }

    /**
     * remove firebase token while user logout so we will not use it next time he logged in.
     * @private
     */
    _onOAuthChange() {
        if(!this.serviceFactory.oAuth2Service().isAuthorized()){
            this.shutDown();
        }
    }

    /**
     * some browsers (like chrome) auto lower case attributes data. This is a fix for other browsers like IE
     * @param params
     * @private
     */
    _setParamsToLowerCase(params){
        for(let param in params){
            let originalParamValue = params[param];
            let newParam = param.toLowerCase();
            delete params[param];
            params[newParam] = originalParamValue;
        }
    }

    /**
     * append script to DOM
     * @private
     */
    _appendScript(){
        let loyaltyScriptLink = this.serviceFactory.loyaltyService().getScriptLink();
        let loyaltyScriptElement = DOM.$$('#loyalty-script');
        if(_.isValidUrl(loyaltyScriptLink) && loyaltyScriptElement.length === 0){
            let script = DOM.createElement('script');
            DOM.addAttribute(script, 'src', loyaltyScriptLink);
            DOM.addAttribute(script, 'id', 'loyalty-script');
            DOM.append(document.body, script);
            script.onload = this._onScriptLoad.bind(this);
        }
        else if(loyaltyScriptElement.length > 0){
            this._onScriptLoad();
        }
    }

    /**
     * handle on script loaded
     * @private
     */
    _onScriptLoad(){
        if(this._firebaseToken) {
            this.logger.info('run loyalty script onload.');

            let userService = this.serviceFactory.userService();

            userService.renewLoginToken().then(userToken => {
                this.getEl().innerHTML = '<div id="rl-loyalty-indication"></div>';

                // if loyalty indication was already initialized and subscribed to triple8messaging
                const currentFirebaseToken = this.serviceFactory.userService().getFirebaseLoginToken();
                if (window.myloyaltyindication && this._firebaseToken && this._firebaseToken === currentFirebaseToken && _.isFunction(window.myloyaltyindication.Terminate)){
                    window.myloyaltyindication.Terminate();
                }

                let skinService = this.serviceFactory.skinService();
                let languageService = this.serviceFactory.languageService();
                this._firebaseToken = currentFirebaseToken;

                let loyaltyInitInfo = {
                    UserInfo: userToken.token,
                    FirebaseToken: this._firebaseToken,
                    CID: this.serviceFactory.userService().getCID(),
                    LanguageCode: languageService.getISO3(),
                    ClientContext: {
                        'BrandId': skinService.getBrandID(),
                        'ClientVersion': skinService.getVersion(),
                        'ProductPackage': skinService.getProductPackageID(),
                        'SubBrandId': skinService.getSubBrandID(),
                        'ClientPlatform': this.serviceFactory.loyaltyService().getClientPlatform()
                    },
                    Logger: window.console,
                    Style: {}
                };
                let styles = this._setStyles();
                Object.assign(loyaltyInitInfo.Style, styles);
                // rlpfweb is inserted by the web department, is related to webLoginComponent
                window.myloyaltyindication = new window.rlpfweb.LoyaltyIndication(loyaltyInitInfo);
                this._onClick();
            });
        } else {
            this.logger.info('not run loyalty script onload. Wait for firebase token, will try again in 1 second');

            this.setTimeout(()=> {
                this._onScriptLoad();
            }, 1000)
        }
    }

    _updateLoyaltyToken(){
        const currentFirebaseToken = this.serviceFactory.userService().getFirebaseLoginToken();
        if (this._firebaseToken !== currentFirebaseToken){
            this._firebaseToken = currentFirebaseToken;
            if(window.myloyaltyindication) {
                window.myloyaltyindication.UpdateToken("", currentFirebaseToken);
            }
        }
    }

    /**
     * set loyalty progress bar styles
     * @private
     */
    _setStyles(){
        let styles = {};
        for(let styleProperty of LOYALTY_STYLE_PROPERTIES){
            let stylePropertyLowerCase = styleProperty.toLowerCase();
            if(this._params[stylePropertyLowerCase]){
                styles[styleProperty] = this._getProperValue(this._params[stylePropertyLowerCase]);
            }
        }
        return styles;
    }

    _getProperValue(value){
        switch(value){
            case 'false':
                return false;
            case 'true':
                return true;
            default:
                return value;
        }
    }

    /**
     * handle loyalty progress bar click
     * @private
     */
    _onClick(){
        window.myloyaltyindication.addEventListener('onloyaltydetailsclick',  ()=> {
            window.CGP.sendAnalytics({
                category: 'loyalty_progress_bar',
                action: "click"
            });
            window.CGP.openExternalLink({
                options:{
                    tabId: 7
                },
                source: 'my_account'
            });
        });
    }

    shutDown() {
        super.shutDown();
        if(window.myloyaltyindication && _.isFunction(window.myloyaltyindication.Terminate)){
            window.myloyaltyindication.Terminate();
        }
    }
}
export default LoyaltyComponentController;